export enum DataEntityTypeEnum {
  Custom = 0,
  ADT,
  Service,
  Request,
  Contact,
  TimelinePost,
  CalendarEvent,
  Notification,
  Task,
  User,
  Group,
  OrganizationUnit,
  Configuration,
  Dashboard,
  Report,
  PostCategory,
  Comment,
  AllRequests,
  Person,
  Role,
  Assignment,
  CounterWidget,
  Domain,
  UserState,
  Link,
  UserGroupAssignment,
  GroupAssignment,
  Fonts,
  Themes,
  TimeZones,
  Settings,
  functions,
  Core = 30,
  System = 40,
  VirtualProxy = 50,
  JoinerVirtualProxy = 51,
  Aggregate = 52,
  Space = 60,
  SpaceUsers = 61,
  Delegation = 70,
  WorkingHours = 71,
  Interceptors = 72,
  Templates = 73,
  Validators = 74,
  SystemObject = 80,
  Audit = 90,
}
